import { Type, Static } from '@sinclair/typebox';
import {
  defineSchema,
  SystemFields,
  StringField,
  BooleanField,
  JsonField,
} from '@ayocore/platform/common/helpers/schema-types';

import { name as moduleName } from '../module.json';
export const ContactChannelSchema = Type.Object(
  {
    ...SystemFields, // Platform-provided system fields (id, created_at, updated_at, uuid)

    contact_type: StringField({
      title: 'Тип контакта',
      maxLength: 30,
      description:
        'Тип контактного канала (email, phone, whatsapp, telegram, linkedin, facebook, skype, viber, etc.)',
    }),

    contact_value: StringField({
      title: 'Значение контакта',
      maxLength: 500,
      description:
        'Фактическая контактная информация (email адрес, номер телефона, имя пользователя, URL, etc.)',
    }),

    label: StringField({
      title: 'Метка',
      maxLength: 50,
      nullable: true,
      description:
        'Метка контакта (основной, рабочий, личный, продажи, поддержка, мобильный, офис, etc.)',
    }),

    description: StringField({
      title: 'Описание',
      maxLength: 255,
      nullable: true,
      description: 'Читаемое описание (например, "Отдел продаж", "Личный WhatsApp директора")',
    }),

    is_verified: BooleanField({
      title: 'Подтвержден',
      default: false,
      description: 'Подтвержден ли этот контактный канал',
    }),

    is_active: BooleanField({
      title: 'Активен',
      default: true,
      description: 'Активен ли этот контактный канал в настоящее время',
    }),

    metadata: JsonField(Type.Any(), {
      title: 'Метаданные',
      nullable: true,
      description:
        'Дополнительные метаданные, специфичные для типа контакта (расширение, код страны, id профиля, etc.)',
    }),
  },
  {
    $id: 'ContactChannel',
    title: 'Контактный канал',
    description: 'Универсальные каналы связи (email, телефон, социальные сети, мессенджеры, etc.)',
    additionalProperties: false,
  }
);

// TypeScript types derived from schemas
export type ContactChannel = Static<typeof ContactChannelSchema>;

// Create type (without system fields)
export type ContactChannelCreate = Omit<
  ContactChannel,
  'id' | 'uuid' | 'created_at' | 'updated_at' | 'sort_order' | 'metadata'
>;

// Schema definition with automatic table prefixing
export default defineSchema({
  moduleName,
  tableName: 'contact_channel', // System will prefix with 'crm_'
  schema: ContactChannelSchema,
  additionalIndexes: ['contact_type', 'contact_value', 'label', 'is_verified', 'is_active'],
  dependencies: [], // No dependencies - standalone table
});
